export default {
  setItem: (key: string, value: any) => {
    // Nếu value là chuỗi (JWT), lưu thẳng
    if (typeof value === 'string') {
      localStorage.setItem(key, value)
    } else {
      localStorage.setItem(key, JSON.stringify(value))
    }
  },

  getItem: (key: string) => {
    const item = localStorage.getItem(key)
    if (!item) return null

    // Nếu item là JSON, parse, nếu không, trả thẳng chuỗi
    try {
      return JSON.parse(item)
    } catch {
      return item
    }
  },

  removeItem: (key: string) => {
    localStorage.removeItem(key)
  },

  updateItem: (key: string, value: any) => {
    const item = localStorage.getItem(key)
    let result = value
    if (item != null) {
      try {
        result = { ...JSON.parse(item), ...value }
      } catch {
        result = value
      }
    }
    localStorage.setItem(key, JSON.stringify(result))
  },

  clear: () => { localStorage.clear() }
}
